import {
  getCoupons,
  createCoupon,
  deleteCoupon,
  checkCoupon,
} from "./asyncThunks";

export const createCouponBuilder = (builder) => {
  builder.addCase(createCoupon.pending, (state) => {
    state.coupons.createLoading = true;
  });
  builder.addCase(createCoupon.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.coupons.data = [data, ...state.coupons.data];
    state.coupons.createLoading = false;
  });
  builder.addCase(createCoupon.rejected, (state, action) => {
    state.coupons.createLoading = false;
    state.coupons.error = action.error.message;
  });
};

export const getCouponsBuilder = (builder) => {
  builder.addCase(getCoupons.pending, (state) => {
    state.coupons.loading = true;
  });
  builder.addCase(getCoupons.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.coupons.data = data;
    state.coupons.loading = false;
  });
  builder.addCase(getCoupons.rejected, (state, action) => {
    state.coupons.loading = false;
    state.coupons.error = action.error.message;
  });
};

export const deleteCouponBuilder = (builder) => {
  builder.addCase(deleteCoupon.pending, (state) => {
    state.coupons.deleteLoading = true;
  });
  builder.addCase(deleteCoupon.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.coupons.data = state.coupons.data.filter(
      (coupon) => coupon.id !== data.id
    );
    state.coupons.deleteLoading = false;
  });
  builder.addCase(deleteCoupon.rejected, (state, action) => {
    state.coupons.deleteLoading = false;
    state.coupons.error = action.error.message;
  });
};

export const checkCouponBuilder = (builder) => {
  builder
    .addCase(checkCoupon.pending, (state) => {
      state.coupons.checkCouponLoading = true;
      state.coupons.error = null;
    })
    .addCase(checkCoupon.fulfilled, (state, { payload }) => {
      const { data } = payload;

      state.coupons.checkCouponLoading = false;
      state.coupons.applied = data;
    })
    .addCase(checkCoupon.rejected, (state, action) => {
      state.coupons.checkCouponLoading = false;
      state.coupons.applied = null;
      state.coupons.error = action.error.message;
    });
};
